
<!-- Start: Rejwan: 09-02-2026 Front Routes -->
<template>
    <div>
        <b-form>                      
            <div class="clearfix">
                <div class="col-md-6 float-left">       
                   
                    <input type="hidden" v-model="bank_data.id" name="id">
                    
                    <input type="hidden" v-model="bank_data.loan_id" name="id">
                    <b-form-group id="beneficiary_name-group" label="Beneficiary Name"  label-for="beneficiary_name">
                        <b-form-input id="beneficiary_name" name="beneficiary_name" :disabled="dis" v-model="bank_data.beneficiary_name" v-validate="{ required: true, min: 3 }" :state="validateState('beneficiary_name')" aria-describedby="beneficiary_name-feedback" data-vv-as="Beneficiary Name"></b-form-input>
                        <b-form-invalid-feedback id="beneficiary_name-feedback">{{ veeErrors.first('beneficiary_name') }}</b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group id="bank_name-group" label="Bank Name" class="" label-for="bank_name">
                        <b-form-input id="bank_name" name="bank_name" :disabled="dis" v-model="bank_data.bank_name" ></b-form-input>
                    </b-form-group> 
                    <b-form-group id="routing_number-group" label="Routing No." class="" label-for="routing_number">
                        <b-form-input id="routing_number" name="routing_number" :disabled="dis" v-model="bank_data.routing_number" v-validate="{ decimal:3 }" :state="validateState('routing_number')" aria-describedby="routing_number-feedback" data-vv-as="Routing No."></b-form-input>
                        <b-form-invalid-feedback id="routing_number-feedback">{{ veeErrors.first('routing_number') }}</b-form-invalid-feedback>
                    </b-form-group>                     
                </div>
                <div class="col-md-6 float-right">
                    <b-form-group id="account_no-group" label="Account No."  label-for="account_no">
                        <b-form-input id="account_no" name="account_no" :disabled="dis" v-model="bank_data.account_no" v-validate="{ required: true, min: 3, decimal:3 }" :state="validateState('account_no')" aria-describedby="account_no-feedback" data-vv-as="Account No."></b-form-input>
                        <b-form-invalid-feedback id="account_no-feedback">{{ veeErrors.first('account_no') }}</b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group id="branch_name-group" label="Branch Name" class="" label-for="branch_name">
                        <b-form-input id="branch_name" name="branch_name" :disabled="dis" v-model="bank_data.branch_name" ></b-form-input>
                    </b-form-group>

                    <div class="mt-4 ml-4">
                    </div>
                </div>                
            </div>          
        </b-form>
    </div>
</template>
<script>

   export default{
      
    mounted() {
                     
    },
    props: ['pageurl','employee_id','bdata'],
    data(){  
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const minDate = new Date(today);

        return {  
            
            bank_data:this.bdata, 
            bank_names: [
                 { value: null, text: "--Select--" },
             ],   

             dis:true,
 


        }
    },
    methods:
    {   
        
        
    },
    created: function()
    {
       
    }   
}
</script>
<!-- End: Rejwan: 09-02-2026 Front Routes -->